import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconExit = (props) => (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: [_jsx("path", { d: "M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z" }), _jsx("path", { d: "m11 16 5-4-5-4v3.001H3v2h8z" })] }));
const Memo = memo(SvgIconExit);
export default Memo;
//# sourceMappingURL=IconExit.js.map